import { ContentBlockImageBreaker } from '@dfh-corp-sites/ui'
import { GatsbyImage } from 'gatsby-plugin-image'
import React, { useEffect, useMemo } from 'react'

import { SanityContentBlockImageBreaker as SanityContentBlockImageBreakerProps } from '../../../graphql/gatsby'
import { setAnalyticsEvent } from '../../../lib/analytics/state'
import { useSanityRoleBasedContent } from '../../../lib/sanity'
import { getGatsbyImageDataForAsset } from '../../../utils/sanity/image'

const SanityContentBlockImageBreaker = ({
  primaryImage,
  primaryImageAlt,
  secondaryImage,
  secondaryImageAlt,
  roleBasedContent,
}: SanityContentBlockImageBreakerProps) => {
  const { shouldDisplay } = useSanityRoleBasedContent({ roleBasedContent })

  useEffect(() => {
    setAnalyticsEvent({
      _key: 'sanitycontentblock-imagebreaker',
      event: 'select_content',
      content_type: 'sanitycontentblock-imagebreaker',
      item_id: 'sanitycontentblock-imagebreaker',
      title: 'image-breaker',
      label_text: '',
      link_destination: '',
      module_name: 'SanityContentBlock',
      module_variant: 'SanityContentBlockImageBreaker',
    })
  }, [])

  const primaryImageElement = useMemo((): JSX.Element | undefined => {
    const imageData = getGatsbyImageDataForAsset(primaryImage, {
      width: 767,
      height: 510,
      placeholder: 'blurred',
      sizes: '(max-width: 480px) 300px, (max-width: 1023px) 414px, (max-width:1152px) 675px, 766px',
    })

    return imageData ? (
      <div className="relative">
        <GatsbyImage
          image={imageData}
          loading="eager"
          alt={primaryImageAlt || ''}
          className="w-full"
        />
      </div>
    ) : undefined
  }, [primaryImage, primaryImageAlt])

  const secondaryImageElement = useMemo((): JSX.Element | undefined => {
    const imageData = getGatsbyImageDataForAsset(secondaryImage, {
      width: 319,
      height: 319,
      placeholder: 'blurred',
      sizes: '(max-width: 480px) 125px, (max-width: 1023px) 172px, (max-width:1152px) 281px, 319px',
    })

    return imageData ? (
      <div className="relative">
        <GatsbyImage
          image={imageData}
          loading="eager"
          alt={secondaryImageAlt || ''}
          className="w-full"
        />
      </div>
    ) : undefined
  }, [secondaryImage, secondaryImageAlt])

  if (!shouldDisplay) return null
  return (
    <ContentBlockImageBreaker
      primaryImage={primaryImageElement}
      secondaryImage={secondaryImageElement}
    />
  )
}
export default SanityContentBlockImageBreaker
